import * as React from "react";
import {connect} from "react-redux";
import {
    autoLocalize,
    AutoLocalize,
    setAutoLocalizeModalVisibility,
    SetAutoLocalizeModalVisibility
} from "../actions";
import * as selectors from "../selectors";
import LocationalState, {LocationalRoadObjectType} from "../LocationalState";
import {Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle} from "react-bootstrap";
import classNames from "classnames";

interface TagProps {

}

interface DispatchProps {
    doAutolocalize: AutoLocalize,
    doShowModal: SetAutoLocalizeModalVisibility
}

interface StateProps {
    roadObjectTypes: LocationalRoadObjectType[],
    showModal: boolean
}


type Props = TagProps & StateProps & DispatchProps;

const mapStateToProps = (state: LocationalState): StateProps => {
    return {
        roadObjectTypes: selectors.locationalRoadObjectTypes(state),
        showModal: selectors.showAutoLocalizeModal(state)
    };
};

const mapDispatchToProps: DispatchProps = ({
    doAutolocalize: autoLocalize,
    doShowModal: setAutoLocalizeModalVisibility
});

class Component extends React.Component<Props> {

    constructor(props: Props) {
        super(props);
    }

    render() {
        const {roadObjectTypes} = this.props;
        return (
            <>
                <div className={"autolocalizeTool"}>
                    <button className={"btn"} onClick={() => this.handleShowModal()}>Automatisert stedfesting</button>
                </div>
                {this.props.showModal &&
                (<AutolocalizeModal roadObjectTypes={roadObjectTypes}
                                    doCloseModal={() => this.handleCloseModal()}
                                    doLocalize={this.handleDoAutolocalize.bind(this)}
                />)
                }
            </>
        );
    }

    handleShowModal() {
        this.props.doShowModal(true);
    }

    handleCloseModal() {
        this.props.doShowModal(false);
    }

    handleDoAutolocalize(rots: number[]) {
        this.props.doAutolocalize(rots);
    };
}

export const AutolocalizeTool = connect(mapStateToProps, mapDispatchToProps)(Component);

interface ModalProps {
    roadObjectTypes: LocationalRoadObjectType[],
    doCloseModal: Function,
    doLocalize: Function,
}

interface ModalState {
    selectedRots: number[],
}

class AutolocalizeModal extends React.Component<ModalProps, ModalState> {

    constructor(props: ModalProps) {
        super(props);
        this.state = {
            selectedRots: props.roadObjectTypes.map(rot => rot.typeid),
        }
    }



    render() {

        let {roadObjectTypes} = this.props;

        let totalNumOfRots = roadObjectTypes.length;
        let numOfRots = this.state.selectedRots.length === totalNumOfRots ? "alle" : this.state.selectedRots.length;
        let allChosen = this.state.selectedRots.length === totalNumOfRots;
        let selectCountValid = this.state.selectedRots.length > 0;

        return (
            <Modal show={true} onHide={() => this.closeModal()} className={"autolocalize-modal"}>
                <ModalHeader>
                    <ModalTitle>Automatisert stedfesting</ModalTitle>
                </ModalHeader>

                <ModalBody>
                    <div className="body" >
                        <div className={"rotlist-container"}>
                            <h2 className={"h4"}>
                                Vegobjekttyper
                                <span className={!selectCountValid ? "select-count-invalid" : ""}>
                                    ({numOfRots} valgt)
                                </span>
                                <br/>
                                <label title="Velg alle">
                                    <input type={"checkbox"}
                                           onChange={() => this.handleToggleAll(roadObjectTypes, allChosen)}
                                           checked={allChosen}
                                    /> Velg alle
                                </label>
                                <br/>
                            </h2>
                            <ul>
                                {roadObjectTypes.map(rot => {

                                    let rotClasses = classNames({
                                        "selected": this.state.selectedRots.some(rotid => rotid === rot.typeid),
                                    });

                                    return (<li key={rot.typeid} className={rotClasses}
                                                onClick={() => this.toggleSelected(rot.typeid)}>{rot.name}</li>);
                                })}
                            </ul>
                        </div>
                        <div className={"autolocalize-info"}>
                            <p>
                                Automatisert stedfesting lar Datafangst lage stedfestinger basert på nærhet til veger og vegenes kategori.
                            </p>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    {!selectCountValid && (
                        <p className={"select-count-invalid"}>Du må velge minst én vegobjekttype for å utføre stedfesting.</p>
                    )}
                    <Button disabled={!selectCountValid} onClick={() => this.handleLocalize()}>Stedfest {numOfRots} vegobjekttyper</Button>
                    <button className={"btn btn-secondary"} onClick={() => this.closeModal()}>Avbryt</button>
                </ModalFooter>
            </Modal>
        )
    }

    handleLocalize(){
        this.props.doCloseModal();
        this.props.doLocalize(this.state.selectedRots);
    }

    closeModal() {
        this.props.doCloseModal();
    }

    handleToggleAll = (roadObjectTypes: LocationalRoadObjectType[], allChosen: boolean) => {
        let selectedRots: number[];
        if (allChosen) {
            selectedRots = [];
        } else {
            selectedRots = roadObjectTypes.map(r => r.typeid);
        }
        this.setState({
            selectedRots: selectedRots,
        });
    }

    toggleSelected(rotid: number) {
        if (this.state.selectedRots.some(id => id === rotid)) {
            this.setState({
                selectedRots: this.state.selectedRots.filter(id => {
                    return id != rotid;
                }),
            })
        } else {
            this.setState({
                selectedRots: this.state.selectedRots.concat([rotid]),
            })
        }
    }
}